import React, {useEffect, useState} from 'react';
import ReactWordcloud from 'react-wordcloud';
import {useQuery} from "@apollo/react-hooks";
import {makeStyles} from "@material-ui/core/styles";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import {GET_KEYWORDS_OF_CONTACT} from "../../database/queries/contactQueries";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    cloudContainer: {
        width: '100%',
        '& div > svg': {
            display: 'unset!important'
        },
    },
    keywordBox: {
        // border: '1px solid #d3d4d5',
        width: '100%',
        textAlign: 'center',
    }
}));

const PopupContactKeywordCloud = props => {
    const classes = useStyles();
    const [cloudWords, setCloudWords] = useState([]);
    const [globalLayoutState] = useLayoutStore();

    const {loading: getKeywordsOfContactLoading, error: getKeywordsOfContactError, data: getKeywordsOfContactData} = useQuery(GET_KEYWORDS_OF_CONTACT, {
        skip: !props.editId,
        variables: {
            contactId: props.editId,
            limit: 40,
            orderList: ['count DESC']
        },
    });

    useEffect(() => {
        if (getKeywordsOfContactError) notify('getKeywordsOfContactError', 'error', getKeywordsOfContactError.message);
    }, [getKeywordsOfContactError]);

    useEffect(() => {
    }, [globalLayoutState.tabBarHeight]);

    useEffect(() => {
        let myCloudWords = [];
        console.log('getKeywordsOfContactData', getKeywordsOfContactData);

        if (getKeywordsOfContactData && getKeywordsOfContactData.keywordsOfContact) {
            for (let k = 0; k < getKeywordsOfContactData.keywordsOfContact.length; k++) {
                // if (!getKeywordsOfContactData.keywordsOfContact[k].keyword.ignore) {
                myCloudWords.push({
                    text: getKeywordsOfContactData.keywordsOfContact[k].keyword.keyword,
                    value: getKeywordsOfContactData.keywordsOfContact[k].count
                })
                // }
            }
            setCloudWords(myCloudWords);
        }
    }, [getKeywordsOfContactData]);

    if (getKeywordsOfContactLoading) return <p>Loading ...</p>;

    const options = {
        colors: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b'],
        enableTooltip: true,
        deterministic: false,
        fontFamily: 'impact',
        fontSizes: [12, 60],
        fontStyle: 'normal',
        fontWeight: 'normal',
        padding: 1,
        rotations: 1,
        rotationAngles: [0, 0],
        scale: 'sqrt',
        spiral: 'archimedean',
        transitionDuration: 1000,
    };

    const boxHeight = window.innerHeight - (globalLayoutState.tabBarHeight + 200);

    return (
        <div className={classes.cloudContainer}>
            {cloudWords && (
                <div className={classes.keywordBox} style={{height: boxHeight}}>
                    {cloudWords && (
                        <ReactWordcloud style={{display: 'unset'}} options={options} words={cloudWords}
                                        size={[500, boxHeight-30]}/>
                    )}
                </div>
            )}
        </div>
    );
};

export default PopupContactKeywordCloud
